export default "__VITE_ASSET__BDtsOdpx__"